import { PageHeader } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { LoginForm } from '../../widgets/LoginForm/LoginForm';

export const AuthenticationPage = () => {
  const { t } = useI18n();

  return (
    <>
      <PageHeader>
        <PageHeader.Title>{t('users:welcome')}</PageHeader.Title>
      </PageHeader>
      <LoginForm />
    </>
  );
};
